// extracted by mini-css-extract-plugin
module.exports = {"navbar":"TenantManagement_navbar__1_a7F","navbarFontStyle":"TenantManagement_navbarFontStyle__24vAY","navbarSelectedItemStyle":"TenantManagement_navbarSelectedItemStyle__Mu7ab"};